import { HardHat, Phone, Mail, MapPin, MessageCircle } from "lucide-react";
import { BRAND, NAV_LINKS } from "@/lib/brand";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="relative bg-[#0B1528] text-white overflow-hidden">
      <div className="absolute inset-0 blueprint-grid opacity-30" />
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid md:grid-cols-4 gap-10">
          {/* Brand */}
          <div className="md:col-span-2">
            <div className="flex items-center gap-2.5 mb-5">
              <span className="inline-flex items-center justify-center w-10 h-10 rounded-lg bg-[#F26522] text-white">
                <HardHat className="w-5 h-5" strokeWidth={2.5} />
              </span>
              <div>
                <div className="font-display font-extrabold text-lg">AMLOU</div>
                <div className="text-[10px] uppercase tracking-[0.18em] text-white/60 font-mono-accent">
                  Construcciones · Reformas
                </div>
              </div>
            </div>
            <p className="text-slate-300 text-sm leading-relaxed max-w-md">
              {BRAND.fullName}. Especialistas en obra nueva, reformas integrales, rehabilitación
              de edificios y fachadas en Cunit, Tarragona y alrededores.
            </p>

            <div className="mt-6 flex flex-wrap gap-2">
              <a
                href={BRAND.whatsappUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-[#25D366] hover:bg-[#20BA57] text-white text-sm font-semibold transition-colors"
              >
                <MessageCircle className="w-4 h-4" /> WhatsApp
              </a>
              <a
                href="#contacto"
                className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-[#F26522] hover:bg-[#D95212] text-white text-sm font-semibold transition-colors"
              >
                Solicitar Presupuesto
              </a>
            </div>
          </div>

          {/* Nav */}
          <div>
            <h4 className="font-display font-bold mb-4 text-white">Navegación</h4>
            <ul className="space-y-2.5">
              {NAV_LINKS.map((l) => (
                <li key={l.id}>
                  <a
                    href={`#${l.id}`}
                    className="text-slate-400 hover:text-[#F26522] text-sm transition-colors"
                  >
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-display font-bold mb-4 text-white">Contacto</h4>
            <ul className="space-y-3">
              <li>
                <a href={BRAND.phonePrimaryHref} className="flex items-start gap-2.5 text-slate-300 hover:text-[#F26522] transition-colors text-sm">
                  <Phone className="w-4 h-4 mt-0.5 shrink-0" />
                  <span className="font-mono-accent">{BRAND.phonePrimary}</span>
                </a>
              </li>
              <li>
                <a href={BRAND.phoneSecondaryHref} className="flex items-start gap-2.5 text-slate-300 hover:text-[#F26522] transition-colors text-sm">
                  <Phone className="w-4 h-4 mt-0.5 shrink-0" />
                  <span className="font-mono-accent">{BRAND.phoneSecondary}</span>
                </a>
              </li>
              <li>
                <a href={BRAND.emailHref} className="flex items-start gap-2.5 text-slate-300 hover:text-[#F26522] transition-colors text-sm break-all">
                  <Mail className="w-4 h-4 mt-0.5 shrink-0" />
                  {BRAND.email}
                </a>
              </li>
              <li className="flex items-start gap-2.5 text-slate-300 text-sm">
                <MapPin className="w-4 h-4 mt-0.5 shrink-0" />
                Cunit (Tarragona)
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-white/10 flex flex-col sm:flex-row justify-between items-start sm:items-center gap-3">
          <p className="text-xs text-slate-500 font-mono-accent">
            © {BRAND.year} {BRAND.fullName} · Todos los derechos reservados
          </p>
          <p className="text-xs text-slate-500">
            Cunit · Tarragona · Cataluña · España
          </p>
        </div>
      </div>
    </footer>
  );
}
